import React from 'react';
import { motion } from 'framer-motion';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
interface MarketRealitySlideProps {
  content: {
    headline: string;
    highlight: string;
    text: string;
    source: string;
    data: Array<{
      name: string;
      value: number;
      color: string;
    }>;
  };
}
export function MarketRealitySlide({
  content
}: MarketRealitySlideProps) {
  return <div className="bg-[#F5F5F5] rounded-2xl p-12 min-h-[600px] flex flex-col relative" data-id="element-157">
      <motion.h2 initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-4xl font-bold text-[#1C1C1C] mb-8 text-center" data-id="element-158">
        {content.headline}
      </motion.h2>

      <div className="flex-1 flex items-center gap-12" data-id="element-159">
        {/* Chart Area */}
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="w-1/2 h-[400px]" data-id="element-160">
          <ResponsiveContainer width="100%" height="100%" data-id="element-161">
            <PieChart data-id="element-162">
              <Pie data={content.data} cx="50%" cy="50%" innerRadius={100} outerRadius={140} paddingAngle={5} dataKey="value" stroke="none" data-id="element-163">
                {content.data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-164" />)}
              </Pie>
              <Tooltip formatter={(value: number) => [`${value}%`, 'Traffic']} contentStyle={{
              borderRadius: '8px',
              border: 'none',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }} data-id="element-165" />
              <Legend verticalAlign="bottom" height={36} iconType="circle" data-id="element-166" />
            </PieChart>
          </ResponsiveContainer>
        </motion.div>

        {/* Text Area */}
        <div className="w-1/2 space-y-8" data-id="element-167">
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4
        }} className="bg-[#017C6D] p-8 rounded-xl shadow-lg border-l-8 border-[#0FB07D]" data-id="element-168">
            <p className="text-3xl font-bold text-white leading-tight" data-id="element-169">
              {content.highlight}
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.6
        }} className="text-2xl text-[#4D4D4D] leading-relaxed" data-id="element-170">
            {content.text}
          </motion.p>
        </div>
      </div>

      <div className="absolute bottom-6 right-8 text-sm text-[#4D4D4D]/60 font-medium" data-id="element-171">
        {content.source}
      </div>
    </div>;
}
export default MarketRealitySlide;